import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { useAction } from '../useAction';
import { useAsyncState } from '../useAsyncState';

export interface UseUpdateOrganizationResult {
	isErrored: boolean;
	isFailed: boolean;
	isSuccessful: boolean;
	request: typeof coreActions.requestPatchCoreOrganizationsById;
	reset: typeof coreActions.resetPatchCoreOrganizationsById;
}

const selectors = createAsyncSelectors((state) => state.core.organizations.byId.patch);

export function useUpdateOrganization(): UseUpdateOrganizationResult {
	const { isErrored, isFailed, isReceived } = useAsyncState(selectors);

	const request = useAction(coreActions.requestPatchCoreOrganizationsById);
	const reset = useAction(coreActions.resetPatchCoreOrganizationsById);

	return {
		isErrored,
		isFailed,
		isSuccessful: isReceived,
		request,
		reset
	};
}

useUpdateOrganization.selectors = selectors;
